import { useSearchParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { Logo } from "@/components/Logo";
import api from "@/lib/api";

export default function PaymentCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("verifying");
  const reference = params.get("reference") || params.get("trxref");

  useEffect(() => {
    if (!reference) { setState("failed"); return; }
    let done = false;
    api.get(`/subscription/verify/${reference}`)
      .then(({ data }) => { if (!done) setState(data.status === "success" ? "success" : "failed"); })
      .catch(() => { if (!done) setState("failed"); });
    return () => { done = true; };
  }, [reference]);

  useEffect(() => {
    if (state === "success") {
      const t = setTimeout(() => { window.location.href = "/dashboard/member"; }, 1800);
      return () => clearTimeout(t);
    }
  }, [state]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#0A0A0B] fl-grid-bg p-6" data-testid="payment-callback-page">
      <div className="w-full max-w-md rounded-2xl border border-zinc-800 bg-zinc-900/70 backdrop-blur-xl p-10 text-center">
        <Logo size="h-8" className="mx-auto mb-8" />
        {state === "verifying" && (<><Loader2 className="w-10 h-10 text-[#E53E3E] animate-spin mx-auto" /><h1 className="mt-5 font-display text-2xl font-black uppercase tracking-tight">Verifying payment…</h1><p className="mt-2 text-zinc-400 text-sm">Confirming your membership with Paystack.</p></>)}
        {state === "success" && (<><CheckCircle2 className="w-12 h-12 text-green-400 mx-auto" /><h1 className="mt-5 font-display text-2xl font-black uppercase tracking-tight">Membership active!</h1><p className="mt-2 text-zinc-400 text-sm">Redirecting you to your dashboard…</p></>)}
        {state === "failed" && (<><XCircle className="w-12 h-12 text-[#E53E3E] mx-auto" /><h1 className="mt-5 font-display text-2xl font-black uppercase tracking-tight">Payment not confirmed</h1><p className="mt-2 text-zinc-400 text-sm">We couldn't verify this payment. If you were charged, it will reconcile automatically.</p><button onClick={() => navigate("/dashboard/member")} className="mt-6 text-[#E53E3E] font-semibold hover:underline" data-testid="callback-back-button">Back to dashboard</button></>)}
      </div>
    </div>
  );
}
